/**
 * LoadingScreen - Full screen loading indicator
 * Supports custom title, icon, and colors for each module
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Dumbbell, Wallet, Heart, Users, Shield } from 'lucide-react';

// Module configurations
const MODULE_CONFIG = {
  default: {
    title: 'MindMap',
    subtitle: 'Loading your second brain...',
    icon: Brain,
    bgColor: 'bg-indigo-600/20',
    iconColor: 'text-indigo-400',
  },
  fittrack: {
    title: 'FitTrack',
    subtitle: 'Antrenman verileriniz yükleniyor...',
    icon: Dumbbell,
    bgColor: 'bg-orange-600/20',
    iconColor: 'text-orange-400',
  },
  cashflow: {
    title: 'CashFlow',
    subtitle: 'Finansal verileriniz yükleniyor...',
    icon: Wallet,
    bgColor: 'bg-emerald-600/20',
    iconColor: 'text-emerald-400',
  },
  moodmap: {
    title: 'MoodMap',
    subtitle: 'Ruh haliniz yükleniyor...',
    icon: Heart,
    bgColor: 'bg-pink-600/20',
    iconColor: 'text-pink-400',
  },
  mindmap: {
    title: 'MindMap',
    subtitle: 'Haritalarınız yükleniyor...',
    icon: Brain,
    bgColor: 'bg-indigo-600/20',
    iconColor: 'text-indigo-400',
  },
  coach: {
    title: 'Coach',
    subtitle: 'Koçluk paneli yükleniyor...',
    icon: Users,
    bgColor: 'bg-blue-600/20',
    iconColor: 'text-blue-400',
  },
  admin: {
    title: 'Admin',
    subtitle: 'Yönetici paneli yükleniyor...',
    icon: Shield,
    bgColor: 'bg-red-600/20',
    iconColor: 'text-red-400',
  },
};

const LoadingScreen = ({
  module = 'default',
  title,
  subtitle,
  icon: CustomIcon,
  bgColor,
  iconColor,
}) => {
  // Get config from module or use custom props
  const config = MODULE_CONFIG[module] || MODULE_CONFIG.default;

  const finalTitle = title || config.title;
  const finalSubtitle = subtitle || config.subtitle;
  const IconComponent = CustomIcon || config.icon;
  const finalBgColor = bgColor || config.bgColor;
  const finalIconColor = iconColor || config.iconColor;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-950">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center"
      >
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            opacity: [1, 0.8, 1],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className={`w-16 h-16 ${finalBgColor} rounded-2xl flex items-center justify-center mb-4`}
        >
          <IconComponent size={32} className={finalIconColor} />
        </motion.div>
        <h1 className="text-xl font-semibold text-white mb-2">{finalTitle}</h1>
        <p className="text-gray-500 text-sm">{finalSubtitle}</p>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
